"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CharSource = void 0;
var Bookmark_1 = require("../Bookmark");
var StringBuilder_1 = require("./StringBuilder");
var EOFRuntimeException_1 = require("./EOFRuntimeException");
var ParseRuntimeException_1 = require("./ParseRuntimeException");
var CharSource = /** @class */ (function () {
    function CharSource() {
        this.bookmark = new Bookmark_1.Bookmark();
    }
    CharSource.prototype.peek = function (i) {
        if (i === void 0) { i = 0; }
        return '';
    };
    CharSource.prototype.isEof = function (i) {
        if (i === void 0) { i = 0; }
        return false;
    };
    CharSource.prototype.getBookmark = function () {
        return this.bookmark.clone();
    };
    CharSource.prototype.skipUntil = function (predicate) {
        return this.readUntil(null, predicate);
    };
    /** @return true Terminal conditions matches  */
    CharSource.prototype.readUntilTerminatorToString = function (target, chars, strs, include, minLen, maxLen) {
        var _this = this;
        if (strs === void 0) { strs = null; }
        if (include === void 0) { include = true; }
        if (minLen === void 0) { minLen = 0; }
        if (maxLen === void 0) { maxLen = Number.MAX_VALUE; }
        return this.readUntil(target, function (s) { return (chars.indexOf(s.peek(0)) >= 0 || _this.startsWithAny(strs)) === include; }, minLen, maxLen);
    };
    /** @return true Terminal conditions matches  */
    CharSource.prototype.readUntilTerminator = function (chars, strs, minLen, maxLen) {
        if (strs === void 0) { strs = null; }
        if (minLen === void 0) { minLen = 0; }
        if (maxLen === void 0) { maxLen = Number.MAX_VALUE; }
        var sb = new StringBuilder_1.StringBuilder();
        this.readUntilTerminatorToString(sb, chars, strs, true, minLen, maxLen);
        return sb.toString();
    };
    /** @return true Terminal conditions matches  */
    CharSource.prototype.skipUntilTerminator = function (chars, include) {
        if (include === void 0) { include = true; }
        return this.readUntilTerminatorToString(null, chars, null, include);
    };
    /** @return true Indicates more character in the stream  */
    CharSource.prototype.skipSpacesAndReturns = function () { return this.skipUntilTerminator(CharSource.SPACE_RETURN_CHARS, false); };
    CharSource.prototype.skipSpacesAndReturnsAndCommas = function () { return this.skipUntilTerminator(CharSource.SPACE_RETURN_COMMA_CHARS, false); };
    /** @return true Indicates more character in the stream  */
    CharSource.prototype.skipChars = function (chars) { return this.skipUntilTerminator(chars, false); };
    CharSource.prototype.readToString = function (target, len) {
        return this.readUntil(target, function (s) { return false; }, len, len);
    };
    CharSource.prototype.readString = function (len) {
        var sb = new StringBuilder_1.StringBuilder();
        this.readToString(sb, len);
        return sb.toString();
    };
    CharSource.prototype.skip = function (len) {
        if (len === void 0) { len = 1; }
        return this.readToString(null, len);
    };
    CharSource.prototype.readUntilMatch = function (target, str, skipStr, minLen, maxLen) {
        if (minLen === void 0) { minLen = 0; }
        if (maxLen === void 0) { maxLen = CharSource.MAX_STRING_LEN; }
        var matches = this.readUntil(target, function (s) { return s.startsWith(str); }, minLen, maxLen);
        if (matches && skipStr)
            this.skip(str.length);
        return matches;
    };
    CharSource.prototype.skipUntilMatch = function (str, skipStr) {
        return this.readUntilMatch(null, str, skipStr);
    };
    // TODO: performance optimization with string.substr()
    CharSource.prototype.peekString = function (len) {
        var sb = new StringBuilder_1.StringBuilder();
        for (var i = 0; i < len; i++) {
            if (this.isEof(i))
                break;
            sb.append(this.peek(i));
        }
        return sb.toString();
    };
    CharSource.prototype.startsWithAny = function (strs) {
        if (strs != null) {
            for (var _i = 0, strs_1 = strs; _i < strs_1.length; _i++) {
                var s = strs_1[_i];
                if (this.startsWith(s))
                    return true;
            }
        }
        return false;
    };
    CharSource.prototype.startsWith = function (str) {
        if (this.isEof(str.length - 1))
            return false;
        for (var i = 0; i < str.length; i++) {
            if (this.peek(i) !== str.charAt(i))
                return false;
        }
        return true;
    };
    // For performance, avoid creating String object every time
    CharSource.prototype.getTermStrWithQuoteAndEscape = function (quote) {
        switch (quote) {
            case "'":
                return "\\'";
            case '"':
                return '\\"';
            case '`':
                return '\\`';
            default:
                return '\\';
        }
    };
    CharSource.prototype.readQuotedString = function (quote) {
        return this.readQuotedToString(new StringBuilder_1.StringBuilder(), quote).toString();
    };
    CharSource.prototype.readQuotedToString = function (sb, quote) {
        var terminator = this.getTermStrWithQuoteAndEscape(quote);
        // Not calling getBookmark() to avoid clone an object
        var pos = this.bookmark.pos;
        var line = this.bookmark.line;
        var col = this.bookmark.col;
        while (true) {
            if (!this.readUntilTerminatorToString(sb, terminator))
                throw new EOFRuntimeException_1.EOFRuntimeException("Can't find matching quote at position:" + pos + ";line:" + line + ";col:" + col);
            var c = this.read();
            if (c === quote)
                break;
            // c should be '/', tt's a escape sequence
            c = this.read();
            switch (c) {
                case 'b':
                    sb.append('\b');
                    break;
                case 't':
                    sb.append('\t');
                    break;
                case 'n':
                    sb.append('\n');
                    break;
                case 'f':
                    sb.append('\f');
                    break;
                case 'r':
                    sb.append('\r');
                    break;
                case 'v':
                    sb.append('\u000B');
                    break;
                case 'u':
                    var code = parseInt(this.readString(4), 16);
                    if (Number.isNaN(code))
                        throw this.createParseRuntimeException('Escaped unicode with invalid number: ' + code);
                    sb.append(String.fromCharCode(code));
                    break;
                case '\n':
                case '\r':
                    break; // Assume it's a line continuation
                default:
                    if (this.isOctDigit(c))
                        sb.append(String.fromCharCode(this.readOctNumber(Number(c))));
                    else
                        sb.append(c);
            }
        }
        return sb;
    };
    CharSource.prototype.readOctNumber = function (num) {
        for (var i = 0; i < 2; i++) {
            var d = this.peek();
            if (!this.isOctDigit(d))
                break;
            var newNum = num * 8 + Number(d);
            if (newNum > 255)
                break;
            num = newNum;
            this.read();
        }
        return num;
    };
    CharSource.prototype.isOctDigit = function (c) {
        return '0' <= c && c <= '8';
    };
    CharSource.prototype.createParseRuntimeException = function (message) {
        return new ParseRuntimeException_1.ParseRuntimeException(message, this.getBookmark(), this.peekString(10));
    };
    CharSource.MAX_STRING_LEN = 20000;
    // HTML &nbsp; will be converted to \u00a0, that's why it need to be supported here
    CharSource.SPACE_RETURN_CHARS = ' \n\r\t\u00a0';
    CharSource.SPACE_RETURN_COMMA_CHARS = CharSource.SPACE_RETURN_CHARS + ",";
    return CharSource;
}());
exports.CharSource = CharSource;
//# sourceMappingURL=CharSource.js.map